import { fansupportPublic } from "../index";
/**
 * Fetches campaign data from the server.
 *
 * @return {Promise} A promise that resolves to an object containing the
 * campaign data.
 */
export const getCampaignInNumbers = async () => {
    return fansupportPublic.get('campaign/campaigns-info')
};